<template lang="pug">
.bar__wrapper
  .bar__loader(v-if="loading")
    q-spinner(color="primary", size="3em")
  bar-chart(v-else, :chartData="chartData", :loading="loading")
</template>

<script setup>
import { backend } from "@/api";
import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue";

import { useEmitter } from "@/services/useEmitter";
import { generateFiltersParams } from "@/services/generateFiltersParams";
import { useStore } from "@/store";
import { handleError } from "@/services/handleErrors";
import { currentLocale } from "@/services/useLocales";
import { gridLocales } from "@/services/useLocales";
import barChart from "../../../shared/charts/bar/barChart.vue";

import i18n from "@/plugins/vue-i18n";

const emitter = useEmitter();

const store = useStore();

const props = defineProps({
  type: { type: String, required: true },
});

const chartData = ref({});
const loading = ref(true);

const generateParams = () => {
  let localQuery = "";
  let localFilters = {};

  let localGrid = store.state.grid["expensesDashboard"];

  if (localGrid) {
    localQuery = localGrid.query || "";
    localFilters = localGrid.filters ? generateFiltersParams(localGrid.filters) : {};
  }

  const params = {
    query: localQuery,
    filters: localFilters,
    type: props.type,
  };

  return params;
};

const getData = async () => {
  const params = generateParams();
  loading.value = true;

  try {
    const { data } = await backend.index("api/v3/expenses_dashboard/charts", { params }, { encodeNestedData: true });

    chartData.value["categories"] = data.categories.map(el => getMonth(new Date(el).getMonth()));
    chartData.value["legend"] = data.legend;
    chartData.value["data"] = data.data;
  } catch (e) {
    handleError(e);
  } finally {
    loading.value = false;
  }
};

const getMonth = month => {
  return i18n["messages"][currentLocale.value]["date"]["monthsShort"][month];
};

onBeforeMount(async () => {
  await getData();

  emitter.on("refresh-expenses-dashboard-data", getData);
});

onBeforeUnmount(() => {
  emitter.off("refresh-expenses-dashboard-data");
});
</script>

<style lang="scss" scoped>
.bar__wrapper {
  width: 50%;
}

.bar__loader {
  min-height: 377px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
